<div class="section-container">
  <sc-title content="Información del cliente" type="h3" [class.sc-color-grey-2]="!editMode"></sc-title>
  <p class="section-description">
    <ng-container *ngIf="showAddress">Datos para el envío de papeleria</ng-container>
  </p>
  <form [formGroup]="formGroup" *ngIf="editMode">
    <div class="form-container">
      <ng-container *ngIf="showAddress">
        <div class="row">
          <div class="col-8">
            <sc-input label="Calle" formControlName="street" placeholder="Montevideo"></sc-input>
          </div>
          <div class="col-4">
            <sc-input label="Número" formControlName="streetNumber" placeholder="1123"></sc-input>
          </div>
        </div>
        <div class="row">
            <div class="col-4">
              <sc-input label="Piso" formControlName="floor" placeholder="Ej.: 3"></sc-input>
            </div>
            <div class="col-4">
              <sc-input label="Dpto" formControlName="department" placeholder="Ej.: D"></sc-input>
            </div>
        </div>
      </ng-container>
      <div class="row">
        <div class="col-8">
          <sc-input
            formControlName="email"
            label="Email"
            placeholder="Escribe el email"
            [errorMessages]="errorMessages"
            [icon]="formGroup.get('email').pending ? 'loading' : (formGroup.get('email').valid) ? 'check' : null"
          ></sc-input>
        </div>
      </div>
      <div class="row" *ngIf="showElectronicDocuments">
        <div class="col-12">
          <sc-electronic-documents-adhesion
            [adhered]="contactData.electronicDocuments"
            (change)="handleElectronicDocumentsChange($event)">
          </sc-electronic-documents-adhesion>
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <sc-phone
            label="Teléfono"
            formControlNameAreaCode="areaCode"
            formControlNamePhoneNumber="phoneNumber"
            areaCodePrefix="0"
            phoneNumberPrefix="15"
            placeholderAreaCode="341"
            placeholderPhoneNumber="5414180"
            [errorMessages]="errorMessages"
          ></sc-phone>
        </div>
      </div>
      <div class="row" *ngIf="showElectronicDocuments">
        <div class="col-12 electronic-documents-message">
          <sc-info-box>
            Adhiriendo tu cliente a póliza digital garantizás la entrega de la papelería en formato digital y sumás puntos para el PIP.
          </sc-info-box>
        </div>
      </div>
    </div>
    <div class="buttons-block">
      <sc-button (onClick)="onSubmit()" [disabled]="formGroup.invalid || formGroup.get('email').pending" id="insured-info-emission-next-step">Siguiente</sc-button>
    </div>
  </form>
  <div class="section-submitted-data" *ngIf="!editMode">
    <div *ngIf="formGroup.value.email">
      <ng-container *ngIf="showAddress">
        <div>
          Calle<br>
          <strong>{{formGroup.value.street || '-'}}</strong>
        </div>
        <div>
          Numero<br>
          <strong>{{formGroup.value.streetNumber || '-'}}</strong>
        </div>
        <div>
          Piso<br>
          <strong>{{formGroup.value.floor || '-'}}</strong>
        </div>
        <div>
          Departamento<br>
          <strong>{{formGroup.value.department || '-'}}</strong>
        </div>
      </ng-container>
      <div>
        Email<br>
        <strong>{{formGroup.value.email || '-'}}</strong>
      </div>
      <div>
        Cód. Área<br>
        <strong>{{formGroup.value.areaCode || '-'}}</strong>
      </div>
      <div>
        Teléfono celular<br>
        <strong>{{formGroup.value.phoneNumber || '-'}}</strong>
      </div>
    </div>
</div>
